import { useContext } from 'react';
import { SpotsChartsDataContext } from '../contexts/SpotsChartsDataContext';

export const useSpotsChartsDataContext = () => {
    return useContext(SpotsChartsDataContext);
};
